import { Link } from "react-router-dom";

type ButtonProps = {
    variant?: `Solid` | `Outline`;
    onClick?: () => void;
    href?: string;
    type?: "button" | "submit" | "reset";
    className?: string;
    disabled?: boolean;
    children: React.ReactNode;
    ariaLabel?: string;
};

const Button: React.FC<ButtonProps> = ({
    className = "",
    disabled = false,
    variant = "Solid",
    href,
    type = "button",
    onClick,
    children,
    ariaLabel,
}) => {
    const baseStyles =
        "flex gap-1 text-white items-center px-2.5 py-1.5 rounded hover:bg-button/10 transition-colors ease-linear";
    const solidStyle = "bg-button";
    const outlineStyle =
        "border border-button hover:bg-button ease-linear";
    const combinedStyles = `${baseStyles} ${variant === "Solid" ? solidStyle : outlineStyle} ${className}`;

    if (href) {
        return (
            <Link
                to={href}
                className={combinedStyles}
                aria-label={ariaLabel}
            >
                {children}
            </Link>
        );
    }

    return (
        <button
            type={type}
            onClick={onClick}
            className={combinedStyles}
            disabled={disabled}
            aria-label={ariaLabel}
        >
            {children}
        </button>
    );
};

export default Button;
